import { useCallback, useMemo, useState } from 'react';
import { getCoursesListRequest } from '../../../../api/requests/sectionsMaintainer';
import { Campus } from '../../../../types/campus';
import { Schedule } from '../../../../types/schedule';
import {
  CourseType,
  FormDataResponseType,
  SchoolType,
} from '../../../../types/sectionMaintainerTypes';
import { SelectOptionType } from '@octano/global-ui';

export function useContinuousEducationSectionForm(
  formData: FormDataResponseType | undefined,
) {
  const [coursesOptions, setCoursesOptions] = useState<SelectOptionType[]>([]);
  const [courseNamesOptions, setCourseNamesOptions] = useState<
    SelectOptionType[]
  >([]);
  const [courses, setCourses] = useState<CourseType[]>([]);
  const [loadingCourses, setLoadingCourses] = useState(false);

  const facultyOptions = useMemo(() => {
    return (
      formData?.schools.map((row: SchoolType) => ({
        value: row.id,
        label: row.name,
      })) || []
    );
  }, [formData]);

  const campusOptions = useMemo(() => {
    return (
      formData?.campuses.map((row: Campus) => ({
        value: row.id,
        label: row.name,
      })) || []
    );
  }, [formData]);

  const schedulesOptions = useMemo(() => {
    return (
      formData?.schedules.map((row: Schedule) => ({
        value: row.id ?? '',
        label: row.name,
      })) || []
    );
  }, [formData]);

  const loadCourses = useCallback(
    async (facultyId?: number) => {
      setLoadingCourses(true);
      const { data } = await getCoursesListRequest(facultyId, true);
      if (data) {
        setCourses(data);
        setCoursesOptions(
          data.map((row: CourseType) => ({
            value: row.code,
            label: row.code,
            name: row.name,
          })),
        );
        setCourseNamesOptions(
          data.map((row: CourseType) => ({
            value: row.name,
            label: row.name,
            code: row.code,
          })),
        );
      }
      setLoadingCourses(false);
    },
    [setLoadingCourses],
  );

  return {
    coursesOptions,
    courseNamesOptions,
    courses,
    loadingCourses,
    setLoadingCourses,
    facultyOptions,
    campusOptions,
    schedulesOptions,
    loadCourses,
  };
}
